export const MANUAL_PAYMENT_OPTION = {
  icon: 'deposit',
  title: 'Payment on completion',
};

export const BANK_PAYMENT_OPTION = {
  icon: 'deposit',
  title: 'Payment via Open Banking',
  subtitle:
    'Allows your customer to pay in full via open banking, which will be charged at 1%. Maximum £10,000.',
};

export const DECLINE_OPTION = {
  icon: 'delete-file',
  title: 'Decline job',
};

export const TEST_OPTION = {
  icon: 'delete-file',
  title: 'Decline job',
};
